module.exports = __webpack_public_path__ + "media/src/assets/Images/SuccessGreenTick-ebe2eadc85e725705375811742a629c9.svg";